import { __assign } from "tslib";
/** @jsxRuntime classic */
/** @jsx withSlots */
import * as React from 'react';
import { withSlots, createComponent, getSlots } from '../../../Foundation';
import { getNativeProps, htmlElementProperties } from '../../../Utilities';
import { StackItemStyles as styles } from './StackItem.styles';
var StackItemView = function (props) {
    var children = props.children;
    var nativeProps = getNativeProps(props, htmlElementProperties);
    if (React.Children.count(children) < 1) {
        return null;
    }
    var Slots = getSlots(props, {
        root: 'div',
    });
    return withSlots(Slots.root, __assign({}, nativeProps), children);
};
export var StackItem = createComponent(StackItemView, {
    displayName: 'StackItem',
    styles: styles,
});
export default StackItem;
//# sourceMappingURL=StackItem.js.map